<template>
  <div class="technicalServices">
    <!-- 头部导航 -->
    <headerNav @setParentTitle="setParentTitle"></headerNav>

    <div class="img">
      <img v-if="type == '解决方案'" src="../assets/img/组-566@2x.jpg" alt="" />
      <img v-else :src="bgImg" alt="" />
    </div>
    <div id="img">
      <img
        v-if="type == '解决方案'"
        src="../assets/img/解决方案moli.png"
        alt=""
      />
      <img v-else :src="bgImg2" alt="" />
    </div>
    <!-- 内容部分 -->
    <div class="contentBox">
      <div class="content">
        <div class="title">
          <span>当前位置：</span>
          <span @click="toindex('index')">首页></span>
          <span
            :style="{ color: !parentT ? '#0066CC' : '' }"
            @click="clickTitle(type)"
            >{{ type }}</span
          >

          <!-- 页面底部点入 articleId  二级标题 导航标题二级 除导航栏的三级标题-->
          <span
            v-if="parentT"
            class="two"
            :style="{ color: !title || !sub_articleId ? '#0066CC' : '' }"
            @click="clickSide(value)"
            >>{{ parentT }}</span
          >
          <!-- 导航栏三级菜单 -->
          <span
            class="five"
            v-if="title && sub_articleId"
            style="color: #0066cc"
            @click="click_subTitle(value, element)"
            >>{{ title }}</span
          >
        </div>
        <!-- pc端结构 -->
        <div class="sideContent">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <div class="sideRight">
                  <div class="sideTitle" @click="clickTitle(type)">
                    {{ type }}
                  </div>
                  <div
                    :class="['sideMenu', item.children ? 'subTitle' : '']"
                    v-for="item in contentList"
                    :key="item.id"
                    @click="clickSide(item)"
                  >
                    <div
                      class="displayDiv"
                      :id="item.type == title ? 'displayDiv' : ''"
                    >
                      <span>{{ item.type }} </span>
                      <!--                      <img-->
                      <!--                        v-if="item.children.length != 0"-->
                      <!--                        :src="-->
                      <!--                          item.expand-->
                      <!--                            ? require('../assets/img/jian.png')-->
                      <!--                            : require('../assets/img/tjia.png')-->
                      <!--                        "-->
                      <!--                        alt=""-->
                      <!--                      />-->
                    </div>
                    <div class="sonMenu">
                      <div
                        :class="title == '从头测序' ? 'div' : ''"
                        :id="title == '抗体重组表达' ? 'div' : ''"
                        v-for="v in item.children"
                        :key="v.id"
                        @click.stop="click_subTitle(v, item)"
                      >
                        &nbsp;&nbsp; >> {{ v.type }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <!-- 点技术服务 -->
            <el-col v-show="pageShow1" :span="18">
              <div class="titleContent">>>{{ pageTitle }}</div>
              <div class="listBox">
                <div
                  v-for="item in contentList"
                  :key="item.id"
                  class="titleList"
                  @click.stop="clickSide(item)"
                >
                  <div class="typeTitle">{{ item.type }}</div>
                  <div v-if="item.children">
                    <div
                      v-for="val in item.children"
                      :key="val.id"
                      @click.stop="click_subTitle(val, item)"
                    >
                      <div class="sub_title">{{ val.type }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <!-- 点解决方案 -->
            <el-col v-show="pageShow2" :span="18">
              <div class="titleContent">>>{{ pageTitle }}</div>
              <div class="listBox">
                <div
                  v-for="item in contentList"
                  :key="item.id"
                  class="titleList"
                  @click="clickSide(item)"
                >
                  <div class="typeTitle">{{ item.type }}</div>
                  <div v-if="item.children">
                    <div
                      v-for="val in item.children"
                      :key="val.id"
                      @click.stop="click_subTitle(val, item)"
                    >
                      <div class="sub_title">{{ val.type }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col v-show="!pageShow1 && !pageShow2" :span="18">
              <div class="grid-content bg-purple">
                <div class="titleContent">>>{{ title }}</div>
                <div v-for="item in contentBox" :key="item.id">
                  <div
                    style="
                      font-size: 16px;
                      line-height: 35px;
                      text-indent: 32px;
                      padding: 0 30px;
                    "
                    v-html="item.content"
                    v-if="!item.isMedia"
                  ></div>
                  <img
                    :src="item.mediaPreviewAddress"
                    alt=""
                    v-if="item.isMedia && item.mediaType == 1"
                  />
                </div>
              </div>
              <!-- 信息提交 -->
              <userInfoSubmit :show-contact="false" />
            </el-col>
          </el-row>
        </div>
        <!-- 移动端结构 -->

        <div class="mobileSideContent">
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <div class="sideRight">
                  <div class="sideTitle" @click="clickTitle(type)">
                    {{ type }}
                  </div>
                  <div
                    :class="['sideMenu', item.children ? 'subTitle' : '']"
                    v-for="item in contentList"
                    :key="item.id"
                    @click="clickSide(item)"
                  >
                    <div
                      v-show="pageShow2 == true || pageShow1 == true"
                      class="displayDiv"
                      :id="item.type == '抗体工程' ? 'displayDiv' : ''"
                      :class="
                        item.type == '单克隆抗体测序' ? 'displayDiv2' : ''
                      "
                    >
                      <p>{{ item.type }}</p>

                      <div class="sonMenus" style="margin-left: 1rem">
                        <div
                          v-for="v in item.children"
                          :key="v.id"
                          @click.stop="click_subTitle(v, item)"
                        >
                          >>{{ v.type }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>

            <el-col v-show="!pageShow1 && !pageShow2" :span="18">
              <div class="grid">
                <div class="titleContent" id="titleContent">>>{{ title }}</div>
                <div v-for="item in contentBox" :key="item.id">
                  <div
                    style="
                      font-size: 16px;
                      line-height: 2rem;
                      text-indent: 32px;
                    "
                    v-html="item.content"
                    v-if="!item.isMedia"
                  ></div>
                  <img
                    :src="item.mediaPreviewAddress"
                    alt=""
                    v-if="item.isMedia && item.mediaType == 1"
                  />
                </div>
              </div>
              <!-- 信息提交 -->
              <userInfoSubmit
                :show-contact="false"
                style="margin-left: -5rem"
              />
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <foote @setParentTitle="setParentTitle" @titleClick="titleClick"></foote>
    <!-- 侧边栏 -->
    <sideBar></sideBar>
  </div>
</template>

<script>
import headerNav from "../components/header.vue";
import foote from "../components/foote.vue";
import sideBar from "../components/sideBar.vue";
import userInfoSubmit from "../components/userInfoSubmit";

export default {
  data() {
    return {
      setting: {
        title: "",
        keywords: "",
        description: "",
      },
      bgImg: require("../assets/img/technology.png"),
      pageId: "",
      contentList: [],
      title: "", //标题
      type: "", //一级标题
      articalId: "",
      contentBox: [], //右边数据
      value: {}, //一级
      item: {}, //二级
      element: {}, //三级
      subTitle: "", //三级标题
      parentT: "",
      pageShow1: false,
      pageShow2: false,
      pageTitle: "",
      bgImg2: require("../assets/img/技术服务-1.jpg"),
    };
  },
  components: {
    headerNav,
    foote,
    sideBar,
    userInfoSubmit,
  },
  created() {
    this.articleId = this.$route.params.articleId.split(".")[0];
    // 针对目前三级菜单跳转错误，再header组件中的sub_articleId参数不能传递过来的临时解决方案
    if (
      this.articleId === "ecombinant-antibody-expression" ||
      this.articleId === "de-novo-sequencing"
    ) {
      this.sub_articleId = this.articleId;
    } else {
      this.sub_articleId = "";
    }
    // this.sub_articleId = this.$route.params.sub_articleId;
    // console.log(this.articleId, "parmse");
    if (this.articleId || this.sub_articleId) {
      this.articalList();
      this.pageShow2 = false;
      this.pageShow1 = false;
    } else {
      if (this.pageTitle == "技术服务") {
        this.pageShow1 = true;
        this.pageShow2 = false;
      } else {
        this.pageShow2 = true;
        this.pageShow1 = false;
      }
    }
    this.menuList(true);
  },
  mounted() {
    var str = this.$route.path.split("html");
    if (str[1]) {
      this.$router.push({
        name: "404",
      });
    }
    if (sessionStorage.getItem("title") == "技术服务") {
      this.setting.keywords =
        "技术服务,抗体测序,HDX蛋白构象分析,宿主残留蛋白分析";
      this.setting.description =
        "谱奥特生物科技可对多种生物样本进行单抗测序、多抗测序、抗体从头测序、HDX蛋白构象分析、宿主残留蛋白分析、2D蛋白免疫印迹等专业的一站式检测服务。";
    } else {
      this.setting.keywords =
        "解决方案,抗体工程,药物研发,HCP抗体研发,HCP检测试剂盒开发";
      this.setting.description =
        " 谱奥特生物科技以高精度质谱和化学蛋白质组为核心，围绕药物研发的完整流程，为全球生物医药行业提供抗体工程、药物研发、HCP抗体研发、HCP检测试剂盒开发等新药临床前研发服务解决方案。";
    }
    this.$axios
      .get(`/official-web-api/article-get-by-type-flag/${this.articleId}`)
      .then((res) => {
        if (res.data.code == 200) {
          this.setting.title = res.data.data.seoTitle;
          this.setting.keywords = res.data.data.seoKeyword;
          this.setting.description = res.data.data.seoDescription;
        }
      });

    this.$store.commit("CHANGE_META_INFO", this.setting);
    this.value = JSON.parse(sessionStorage.getItem("val"));
    this.item = JSON.parse(sessionStorage.getItem("item"));
    if (this.item) {
      this.type = this.item.type;
    }
    // 从首页点底部跳转过来 加载侧边栏
    let flag = sessionStorage.getItem("topTitle");
    if (flag) {
      this.titleClick(this.item);
    }
    // 刷新后重新设置二级面包屑
    this.parentT = this.value ? this.value.type : "";
  },
  metaInfo() {
    return {
      title:
        this.setting.title ||
        sessionStorage.getItem("title") +
          "-抗体测序_HDX-MS分析_HCP分析|服务|机构|公司|价格-谱奥特生物科技",
      meta: [
        { name: "keywords", content: this.setting.keywords },
        { name: "description", content: this.setting.description },
      ],
    };
  },
  methods: {
    toindex(val) {
      this.$router.push({
        name: val,
      });
    },
    titleClick(type) {
      this.pageShow1 = false;
      this.pageShow2 = false;
      this.pageTitle = type.type;
      // 请求侧边栏数据

      this.$axios.get("/official-web-api/get-all-menu").then((res) => {
        // console.log(res.data.data, "拿到的数据");
        res.data.data.forEach((item) => {
          if (item.type == this.pageTitle) {
            this.contentList = item.children.map((v) => {
              if (this.expandFlag && this.expandObj.id == v.id) {
                v.expand = true;
              } else {
                v.expand = false;
              }
              return v;
            });
            this.type = item.type;
          }
        });
        // console.log(this.contentList, "点击的子集");
      });
      if (type.type == "技术服务") {
        this.pageShow1 = true;
      } else if (type.type == "解决方案") {
        this.pageShow2 = true;
      }
    },
    setParentTitle(val) {
      setTimeout(() => {
        this.parentT = val.type;
      }, 30);
    },
    // 一级标题
    clickTitle(type) {
      // console.log(type, "ssss");
      // 更新session里面的一级菜单
      sessionStorage.setItem("topTitle", JSON.stringify(this.item));
      // 清除session里面的二级菜单 没改变路由 手动清空二级面包蟹 三级面包屑
      sessionStorage.removeItem("val");
      sessionStorage.removeItem("element");
      this.parentT = "";
      this.title = "";
      this.pageTitle = type;
      if (type == "技术服务") {
        this.pageShow1 = true;
        this.bgImg = require("../assets/img/technology.png");
      } else if (type == "解决方案") {
        this.pageShow2 = true;
        this.bgImg = require("../assets/img/组-566@2x.png");
        // this.bgImg2 = require("../assets/img/解决方案moli.png");
      }
    },
    // 二级标题
    clickSide(val) {
      // console.log(val, "二级标题");
      this.pageShow1 = false;
      this.pageShow2 = false;
      // this.bgImg = require("../assets/img/technology.png");
      sessionStorage.removeItem("topTitle");
      // 更新session里面的二级菜单
      this.value = sessionStorage.setItem("val", JSON.stringify(val));
      if (val.children.length != 0) {
        val.expand = !val.expand;
        this.expandFlag = true;
        this.expandObj = val;
      }
      this.$router.push({
        name: "product-details",
        params: { articleId: val.typeFlag + ".html", sub_articleId: "" },
      });
      this.parentT = this.value ? this.value.type : val.type;
      this.title = this.value ? this.value.type : val.type;
      this.$router.go(0);
    },
    // 三级标题
    click_subTitle(item, val) {
      // debugger
      this.pageShow1 = false;
      this.pageShow2 = false;
      // this.bgImg = require("../assets/img/technology.png");
      sessionStorage.removeItem("topTitle");
      // 设置三级菜单
      // sessionStorage.setItem("element", JSON.stringify(item));
      this.$router.push({
        name: "product-details",
        params: {
          articleId: item.typeFlag + ".html",
          sub_articleId: item.typeFlag,
        },
      });
      setTimeout(() => {
        this.parentT = val.type;
        this.title = item.type;
      }, 30);
      this.$router.go(0);
    },
    articalList() {
      this.$axios
        .get(
          // api +
          `/official-web-api/article-get-by-type-flag/${
            this.sub_articleId != "" && this.sub_articleId != null
              ? this.sub_articleId
              : this.articleId
          }`
        )
        .then((res) => {
          this.contentBox = res.data.data.resourceList;
          // console.log(this.contentBox, "this.contentBox");
          this.title = res.data.data.title;
          // sessionStorage.getItem("val")
          //   ? (this.title = res.data.data.title)
          //   : (this.title = "");
        });
    },
    menuList(flag) {
      this.$axios.get("/official-web-api/get-all-menu").then((res) => {
        // console.log(res.data.data, "拿到的数据");
        // debugger
        res.data.data.forEach((item) => {
          item.children.forEach((val) => {
            // console.log(val.children[0], "TEST");
            // 如果参数articalID跟点击的articleId相等
            if (this.articleId == val.typeFlag) {
              this.contentList = item.children.map((v) => {
                if (this.expandFlag && this.expandObj.id == v.id) {
                  v.expand = true;
                } else {
                  v.expand = false;
                }
                return v;
              });
              this.type = item.type;
            }
            // 点了三级菜单刷新的时候
            if (this.sub_articleId && flag) {
              if (
                val.children
                  // 针对目前三级菜单跳转错误，再header组件中的sub_articleId参数不能传递过来的临时解决方案
                  .map((v) => v.typeFlag)
                  .includes(this.sub_articleId)
              ) {
                this.contentList = item.children.map((v) => {
                  if (this.expandFlag && this.expandObj.id == v.id) {
                    v.expand = true;
                  } else {
                    v.expand = false;
                  }
                  return v;
                });
                this.type = item.type;
              }
            }
          });
        });
        this.expandFlag = false;
        this.expandObj = {};
        // console.log(res.data.data[0].children);
        if (!this.contentList.length) {
          this.contentList = res.data.data[0].children;
        }
        // console.log(this.contentList, "点击的子集");
      });
    },
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        // console.log("路由改变");
        this.value = JSON.parse(sessionStorage.getItem("val")); //二级
        this.item = JSON.parse(sessionStorage.getItem("item")); //一级
        this.element = JSON.parse(sessionStorage.getItem("element")); //三级
        this.sub_articleId = this.$route.params.sub_articleId;
        this.articleId = this.$route.params.articleId;
        this.parentT = this.value ? this.value.type : "";
        this.type = this.item ? this.item.type : "";
        if (this.articleId || this.sub_articleId) {
          this.articalList();
          this.pageShow1 = false;
          this.pageShow2 = false;
        } else {
          if (this.pageTitle == "技术服务") {
            this.pageShow1 = true;
            this.pageShow2 = false;
          } else {
            this.pageShow2 = true;
            this.pageShow1 = false;
          }
        }

        this.menuList();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/technical.scss";

.technicalServices {
  .listBox {
    display: flex;
    flex-wrap: wrap;
    .titleList:hover .typeTitle {
      color: #fff !important;
    }

    .titleList:hover {
      cursor: pointer;
    }

    .titleList {
      width: 50%;
      height: 150px;
      padding: 20px;
      box-sizing: border-box;

      .typeTitle {
        color: #1470c2 !important;
        font-size: 20px;
      }

      .sub_title {
        color: #7a7a7a;
        font-size: 14px;
        padding-left: 20px;
        margin-top: 5px;
      }
    }

    .titleList:hover {
      background: #007aff;
    }
  }

  button {
    background: #142797;
    color: #fff;
    padding: 10px 15px;
    border: none;
  }

  .formBox {
    display: flex;
    // justify-content: space-around;
    justify-content: space-between;

    & > div {
      width: calc(100% / 2.5);
    }
  }

  /deep/ .el-form-item__content {
    display: flex;
  }

  .ruleForm {
    padding-right: 40px;

    img {
      margin-right: 20px;
    }
  }

  .colorTitle {
    color: #1470c2;
  }

  .normalTitle {
    color: #000;
  }

  .img {
    margin-top: 100px;

    img {
      width: 100%;
      z-index: 1;
    }
  }

  .contentBox {
    background: #f2f2f3;
    margin-bottom: -40px;

    .el-row {
      margin: 0;
    }

    .content {
      background: #fff;
      max-width: 1240px;
      margin: auto;
      border-bottom: 1px solid #c8c8c8;
      position: relative;
      top: -40px;
      left: 0;
      // height: 100%;
      // min-height: 1730px;
      .sideContent {
        padding-left: 20px;
        margin-bottom: 30px;

        .sideRight {
          // height: 70px;
          line-height: 70px;
        }
      }

      .title {
        display: inline-block;
        font-size: 16px;
        height: 60px;
        background: #fff;
        margin: 0 auto;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #c8c8c8;
        margin-bottom: 20px;
        padding-left: 30px;

        span {
          color: #7a7a7a;
          font-size: 14px;
        }
      }

      .title span:not(:first-child) {
        cursor: pointer !important;
      }

      .titleContent {
        font-size: 24px;
        height: 60px;
        background: #f5f5f5;
        color: #1470c2;
        line-height: 60px;
        padding-left: 20px;
        margin-right: 20px;
      }
    }
  }

  /deep/ .outBox {
    background: #fff !important;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);

    .el-row {
      color: #000 !important;
    }

    .menu-title {
      color: #000 !important;
    }
  }

  /deep/ #boxRight {
    color: #000 !important;
  }

  .sideMenu .displayDiv {
    font-size: 14px;
    padding: 0 15px;
    border: 1px solid #ddd;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #7a7a7a;
  }
  @media screen and (min-width: 768px) {
    .sideMenu #displayDiv {
      background: #ddd;
    }
  }

  .displayDiv:hover {
    cursor: pointer;
  }

  .sideMenu {
    img {
      width: 18px;
      height: 18px;
    }
  }

  .sideTitle {
    background: #1470c2;
    color: #fff;
    padding-left: 15px;
    font-size: 14px;
  }

  .sideTitle:hover {
    cursor: pointer;
  }
  .sonMenu {
    .div {
      background: #ddd;
    }
    #div {
      background: #ddd;
    }
  }
  .sonMenu > div {
    border-right: 1px solid #ccc;
    border-left: 1px solid #ccc;
    padding-left: 15px;
    font-size: 14px;
    color: #7a7a7a;
  }

  .sonMenu > div:hover {
    cursor: pointer;
  }

  .contentRight {
    padding-left: 20px;
    background-color: #f5f5f5;
    margin-right: 20px;

    .rightTitle {
      font-size: 24px;
      height: 60px;
      line-height: 60px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/product-details.vue